<script setup lang="ts">
import { useVersionCheck } from '@/composables/useVersionCheck';

// Initialize the version check logic.
// This component renders nothing but provides the side effect of checking for updates.
// It should be placed inside App.vue within the NMessageProvider context.
useVersionCheck();
</script>

<template>
  <!-- Invisible component -->
  <div style="display: none;"></div>
</template>
